module.exports = __webpack_public_path__ + "img/stock5.77260db7.png";